var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "editable-editor-wrapper",
      class:
        ((_obj = { focused: _vm.focused }),
        (_obj[" " + _vm.classNames] = true),
        _obj),
      on: {
        focus: function ($event) {
          return _vm.$emit("focus", $event)
        },
        blue: function ($event) {
          return _vm.$emit("blue", $event)
        },
      },
    },
    [
      _vm.privateMessage
        ? _c("editor-content", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content: this.$t("chatbotv2.privateMessageDescription"),
                  placement: "bottom",
                },
                expression:
                  "{ content: this.$t('chatbotv2.privateMessageDescription'), placement: 'bottom' }",
              },
            ],
            staticClass: "editable-editor",
            class: {
              focused: _vm.focused,
              "private-message": _vm.privateMessage,
            },
            attrs: { editor: _vm.editor },
          })
        : _c("editor-content", {
            staticClass: "editable-editor",
            class: {
              focused: _vm.focused,
              "private-message": _vm.privateMessage,
            },
            attrs: { editor: _vm.editor },
          }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: { followCursor: true, placement: "bottom-end" },
              expression: "{ followCursor: true, placement: 'bottom-end' }",
            },
          ],
          staticClass: "text-editor-utils",
          attrs: {
            content:
              _vm.getRemainingCharacterCount() <= 5
                ? this.$t("message.textLimitAlertMessage")
                : "",
          },
        },
        [
          _vm.showAttributes && !_vm.previewMode
            ? _c(
                "div",
                {
                  staticClass: "text-editor-insert-attribute",
                  on: {
                    click: function () {
                      return _vm.appendAttribute()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(" data_object "),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showEmoji && !_vm.previewMode
            ? _c(
                "a-popover",
                {
                  attrs: {
                    trigger: "click",
                    placement: "leftBottom",
                    overlayClassName: "no-padding",
                  },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape",
                        ])
                      ) {
                        return null
                      }
                      _vm.showEmojiPicker = false
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "emoji-container" },
                              [
                                _c("ModalEmojiPicker", {
                                  attrs: {
                                    onPickedEmoji: _vm._handleEmojiPicked,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3990644105
                  ),
                  model: {
                    value: _vm.showEmojiPicker,
                    callback: function ($$v) {
                      _vm.showEmojiPicker = $$v
                    },
                    expression: "showEmojiPicker",
                  },
                },
                [
                  _vm._v(" "),
                  _c("div", { staticClass: "emoji-picker" }, [
                    _c(
                      "div",
                      {
                        staticClass: "emoji-picker-button",
                        attrs: { "aria-expanded": "false" },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(" sentiment_very_satisfied "),
                        ]),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.maxCharacterCount && !_vm.previewMode
            ? _c(
                "div",
                {
                  staticClass: "text-limit",
                  class: { error: _vm.getRemainingCharacterCount() <= 10 },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getRemainingCharacterCount()) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }